import paper from 'paper/dist/paper-core'
import {
  CYCLE_SYMBOL_LABEL,
  PRIMARY_COLOR,
  TRANSPARENT,
  TRANSPARENT_WORKAROUND,
  WHITE,
} from '../../../constants/colors'
import { InteractionState } from '../../planner/types/interactionState'

export class CycleSymbolLabel extends paper.Group {
  public readonly circle: paper.Path
  private readonly label: paper.PointText

  private readonly defaultCircleStyle = {
    strokeColor: CYCLE_SYMBOL_LABEL,
    strokeWidth: 1,
    fillColor: TRANSPARENT,
  } as paper.Style

  private readonly defaultLabelStyle = {
    fillColor: CYCLE_SYMBOL_LABEL,
  } as paper.Style

  private readonly hoverCircleStyle = {
    strokeColor: PRIMARY_COLOR,
    strokeWidth: 1,
    fillColor: PRIMARY_COLOR,
  } as paper.Style

  private readonly hoverLabelStyle = {
    fillColor: WHITE,
  } as paper.Style

  constructor(
    public center: paper.Point,
    public cycleNumber: number,
    public state: InteractionState
  ) {
    super()

    const circle = new paper.Path.Circle(center, 7)
    circle.style =
      state === InteractionState.HOVER || state === InteractionState.SELECTED
        ? this.hoverCircleStyle
        : this.defaultCircleStyle
    this.circle = circle

    const label = new paper.PointText(circle.position.add(new paper.Point(0, 4)))
    label.content = cycleNumber.toString()
    label.justification = 'center'
    label.style =
      state === InteractionState.HOVER || state === InteractionState.SELECTED
        ? this.hoverLabelStyle
        : this.defaultLabelStyle
    this.label = label

    const hitbox = new paper.Path.Circle(center, 15)
    hitbox.fillColor = TRANSPARENT_WORKAROUND

    this.addChildren([circle, label, hitbox])
  }

  getItems(): (paper.Path | paper.PointText)[] {
    return [this.circle, this.label]
  }
}
